 /*******************************************************************************
 * Copyright (c) 2024. dnote.ai
 *
 * @project DNOTE.AI-Frontend
 * @author dnote.ai
 * @copyright Dnote.ai All rights reserved
 ******************************************************************************/

export const  RECEIPT_MODEL = {
     receiptMessage         : null,
     phone                  : null,
     bibleVerse             : null,
     receiptTemplate        : 'TEMPLATE_2',
     creditAccounts         : null,
     receiptPhone           : null,
     receiptType            : "PREDEFINED",
     customModel            : "TEMPLATE_2",
     upi                    : null,
     customReceiptTemplate  : null
}
export const RECEIPT_TEMPLATE = [
   {label: "Template 1"  , value : "TEMPLATE_1"},
   {label: "Template 2"  , value : "TEMPLATE_2"},
   {label: "Template 3"  , value : "TEMPLATE_3"},
   {label: "Template 4"  , value : "TEMPLATE_4"},
   {label: "Template 5"  , value : "TEMPLATE_5"},
]